const baseUrl = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : "";

const apiRoutes = {
  baseUrl: baseUrl,
  auth: {
    login: `${baseUrl}/video/auth/login`,
    sendOtp: `${baseUrl}/video/auth/send-otp`,
    verifyOtp: `${baseUrl}/video/auth/verify-otp`,
    refreshToken: `${baseUrl}/users/refreshToken`,
  },
  cases: {
    myCases: `${baseUrl}/video/cases/myCases`,
    quickViewDetails: `${baseUrl}/video/cases/quickViewDetails`,
    caseDocuments: `${baseUrl}/video/cases/caseDocuments`,
    createCaseDoc: `${baseUrl}/video/cases/createcasedoc`,
  },
  settings: {
    generalSettings: `${baseUrl}/checklistDocuments/options`,
  },
  rooms: {
    list: `${baseUrl}/video/rooms`,
    start: `${baseUrl}/video/rooms/start`,
    complete: `${baseUrl}/video/rooms/complete`,
    waiting: `${baseUrl}/video/rooms/waiting`,
    approve: `${baseUrl}/video/rooms/approve`,
    remove: `${baseUrl}/video/rooms/remove`,
    joinRequest: `${baseUrl}/video/rooms/join/request`,
    adminJoin: `${baseUrl}/video/rooms/admin/join`,
    joinStatus: `${baseUrl}/video/rooms/status`,
    sync: `${baseUrl}/video/rooms/sync`,
    leave: `${baseUrl}/video/rooms/leave`,
    admit: `${baseUrl}/video/rooms/admit`,
    promoteToMeeting: `${baseUrl}/video/rooms/promote-to-meeting`,
    moveToLobby: `${baseUrl}/video/rooms/move-to-lobby`,
    hostRoomToken: `${baseUrl}/video/rooms/host/room-token`,
    lobbyConnected: `${baseUrl}/video/rooms/lobby-connected`,
    meetingConnected: `${baseUrl}/video/rooms/meeting-connected`,
  },
  token: {
    generate: `${baseUrl}/video/token/`,
    refresh: `${baseUrl}/video/token/refresh`,
    encrypt: `${baseUrl}/video/token/encrypt`,
    decrypt: `${baseUrl}/video/token/decrypt`,
  },
  recordings: {
    listByRoom: `${baseUrl}/video/recordings`,
    all: `${baseUrl}/video/recordings/all`,
    start: (sid) => `${baseUrl}/video/recordings/${sid}/start`,
    stop: (sid) => `${baseUrl}/video/recordings/${sid}/stop`,
    fromDb: (sid) => `${baseUrl}/video/recordings/${sid}/db`,
    download: (sid) => `${baseUrl}/video/recordings/${sid}/download`,
  },
  documents: {
    caseDownload: (fileName) =>
      `${baseUrl}/documents/caseDocs/${encodeURIComponent(fileName)}`,
  },
};

export default apiRoutes;
